import React from 'react';
import { Tooltip, theme } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

interface HintLabelProps {
  children: React.ReactNode;
  /** Пояснение: что это за показатель и как его читать. */
  hint: React.ReactNode;
}

/**
 * Подпись с пояснением по наведению (значок ⓘ). Для показателей, которые без
 * объяснения читаются неоднозначно: откуда число, какие пороги что значат.
 */
const HintLabel: React.FC<HintLabelProps> = ({ children, hint }) => {
  const { token } = theme.useToken();
  return (
    <Tooltip title={hint} overlayStyle={{ maxWidth: 360 }}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, cursor: 'help' }}>
        {children}
        <InfoCircleOutlined style={{ color: token.colorTextTertiary, fontSize: '0.85em' }} aria-hidden />
      </span>
    </Tooltip>
  );
};

export default HintLabel;
